import { FC } from 'react'
import {
  StyleCard,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
  StyleTag,
} from './style'
import Image from '@components/image'
import Column from '@components/column'
import Row from '@components/row'
import Typography from '@components/typography'
import Button from '@components/button'
import Status from '../../status'
import ScheduleCard from '../schedule'
interface MedicineOrderRequestCardProps {
  medicine?: any
  styleCard?: string
}

const MedicineOrderRequestCard: FC<MedicineOrderRequestCardProps> = ({
  styleCard = '',
}) => {
  return (
    <StyleCard styleCard={styleCard}>
      <StyleCardHeader>
        <StyleLeftCardHeader>
          <Image
            src={'/'}
            styleImage="border-radius:50%;"
            width={50}
            height={50}
            fallbackType="user"
          />
          <Column rowGap={10}>
            <Typography content="Cameron Williamson" size={14} tc="text" />
            <Row colGap={10}>
              <StyleTag>Male</StyleTag>
              <StyleTag>28</StyleTag>
              <StyleTag>A+</StyleTag>
            </Row>
          </Column>
        </StyleLeftCardHeader>
        <StyleRightCardHeader>
          <Status status="Invoice" />
        </StyleRightCardHeader>
      </StyleCardHeader>
      <Row justifyContent="space-between" colGap={10}>
        <ScheduleCard />
        <Button title="View Details" height={40} radius={8} />
      </Row>
    </StyleCard>
  )
}

export default MedicineOrderRequestCard
